// https://emailregex.com/
const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}))$/;

// https://stackoverflow.com/questions/10306690/what-is-a-regular-expression-which-will-match-a-valid-domain-name-without-a-subd
const domainRegex =
  /^(((?!-))(xn--)?[a-z0-9-_]{0,61}[a-z0-9]{1,1}\.)*(xn--)?([a-z0-9-]{1,61}|[a-z0-9-]{1,30})\.[a-z]{2,}$/;

export const toKebab = (input: string): string =>
  input
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/\s+/g, '-')
    .toLowerCase();

export const toSnakeCase = (text: string): string =>
  text
    .replace(/\s/g, '')
    .split(/(?=[A-Z])/)
    .join('_')
    .toLowerCase();

export const formatUrl = (url: string | undefined): string => {
  if (!url) {
    return '';
  }
  return /^(https?):\/\//.test(url) ? url : `https://${url}`;
};

export const isEmail = (input: string): boolean => emailRegex.test(input);

export const isDomain = (input: string): boolean => domainRegex.test(input);

export const camelCase = (text: string): string =>
  text
    .split(/(?=[A-Z])/)
    .join(' ')
    .toLowerCase();

export const capitalize = (text: string): string => {
  if (typeof text !== 'string') return '';
  return text.charAt(0).toUpperCase() + text.slice(1);
};

export const capitalizeWords = (text: string): string => {
  if (typeof text !== 'string') return '';
  return text.replace(/\b\w/g, (l) => l.toUpperCase());
};

export const titleCase = (text: string): string =>
  capitalize(
    text
      .split(/(?=[A-Z])/)
      .join(' ')
      .toLowerCase()
  );

export const snakeToCamel = (str: string): string =>
  str
    .toLowerCase()
    .replace(/([-_][a-z])/g, (group) =>
      group.toUpperCase().replace(/-/g, '').replace(/_/g, '')
    );

export const removeWhitespace = (str: string): string => str.replace(/\s/g, '');

export const stripHtml = (html: string): string => {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.innerText || '';
};

export const containsHtml = (text: string) => {
  try {
    const fragment = new DOMParser().parseFromString(text, 'text/html');
    return fragment.body.children.length > 0;
  } catch (error) {
    return false;
  }
};
